export enum UploadType {
    Image = 0,
    Document = 1
}